export default __webpack_public_path__ + "static/media/initialDropDate.01018b4f.svg";